import { useEffect, useMemo, useState } from 'react';

import { SEARCH_DEBOUNCE_MS } from '../../../core/constants/forms';
import { formatDateOnly } from '../../../common/utils/date';
import { useOpuList } from '../contexts/opu';
import { useSessionActions } from '../contexts/actions';
import SessionTimeline from './session-timeline';

import './styles/action-search.css';

// Independent action search: its own query (loads results on its own, separate
// from the main list). Find an OPU by code/id, then choose the action by
// clicking a phase circle in its timeline.

export default function OpuActionSearch() {
    const [text, setText] = useState('');
    const [debounced, setDebounced] = useState('');
    const runStep = useSessionActions();

    useEffect(() => {
        const t = setTimeout(() => setDebounced(text.trim()), SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(t);
    }, [text]);

    const filters = useMemo(() => ({ q: debounced, limit: 8 }), [debounced]);
    const { data, isFetching } = useOpuList(filters);
    const results = debounced.length >= 1 ? (data?.items ?? []) : [];

    return (
        <section className="opu-asearch">
            <div className="opu-asearch__head">
                <h2 className="opu-asearch__title">Buscar y accionar</h2>
                <p className="opu-asearch__hint">Buscá una OPU y elegí la acción tocando un círculo del avance.</p>
            </div>

            <div className="opu-asearch__input">
                <input
                    type="search"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Código de OPU (ej. OPU-12)…"
                />
            </div>

            {debounced.length >= 1 && (
                <div className="opu-asearch__results">
                    {isFetching && !results.length ? (
                        <p className="opu-asearch__empty">Buscando…</p>
                    ) : !results.length ? (
                        <p className="opu-asearch__empty">Sin coincidencias.</p>
                    ) : (
                        results.map((s) => (
                            <div key={s.id} className="opu-asearch__item">
                                <div className="opu-asearch__item-info">
                                    <span className="opu-asearch__item-code">{s.code}</span>
                                    <span className="opu-asearch__item-sub">
                                        {formatDateOnly(s.date)}{s.farm?.name ? ` · ${s.farm.name}` : ''}
                                    </span>
                                </div>
                                <SessionTimeline item={s} onStep={(stepKey) => runStep(s, stepKey)} />
                            </div>
                        ))
                    )}
                </div>
            )}
        </section>
    );
}
